import { render, staticRenderFns } from "./hotelImageList.vue?vue&type=template&id=23dc3984&scoped=true"
import script from "./hotelImageList.vue?vue&type=script&lang=js"
export * from "./hotelImageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc3984",
  null
  
)

export default component.exports